import { CUBE_AGGREGATE_INTERACTION } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { CubeQuery, GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { Filter } from '@cubejs-client/core';

const PROMO_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => {
  const baseFilters: Filter[] = [
    {
      member: `${CUBE_AGGREGATE_INTERACTION}.is_1to1visit`,
      operator: 'equals',
      values: ['true'],
    },
  ];

  const query: CubeQuery = {
    dimensions: [`${sourceCube}.activity_type`],
    filters: baseFilters,
    limit: undefined,
  };

  return query;
};

const promoFilter: FilterConfigDynamic = {
  label: 'main.channelFocus.hcpCoverage.filters.promo.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.promo.placeholder',
  clearable: true,
  type: 'multiselect',
  defaultValue: [],
  sourceCube: CUBE_AGGREGATE_INTERACTION,
  getOptionsQuery: PROMO_OPTIONS,
  mapResult: mapDimensionToOption(`${CUBE_AGGREGATE_INTERACTION}.activity_type`),
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${CUBE_AGGREGATE_INTERACTION}.activity_type`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default promoFilter;
